import type { InfiniteTablePropColumns } from "@infinite-table/infinite-react";
import type { BacktestItem } from "epsm-api-types/models";
import { type Dispatch, type SetStateAction, useEffect } from "react";
import { getColumns } from "../helpers/getColumns";

export function useSetColumns(
	setColumnOrder: Dispatch<SetStateAction<string[]>>,
	setColumns: (v: InfiniteTablePropColumns<BacktestItem>) => void,
) {
	useEffect(() => {
		const columnsCall = () => {
			const result = getColumns(setColumnOrder);
			setColumns(result);
		};
		columnsCall();
	}, [setColumns, setColumnOrder]);
}
